// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__2iXFu","item":"items_list_item__3mhfn"};